import React from 'react';

export const Flag = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.63373 16.1387H18.921C19.1031 16.1386 19.2814 16.0867 19.4351 15.9889C19.5887 15.8912 19.7113 15.7517 19.7885 15.5868C19.8658 15.4219 19.8944 15.2384 19.8711 15.0578C19.8478 14.8771 19.7736 14.7069 19.657 14.567L16.1754 10.3887L19.657 6.21034C19.7736 6.07042 19.8478 5.90019 19.8711 5.71959C19.8944 5.53899 19.8658 5.35549 19.7885 5.19058C19.7113 5.02567 19.5887 4.88618 19.4351 4.78843C19.2814 4.69069 19.1031 4.63874 18.921 4.63867H5.63373V21.8887"
      stroke={color || '#6B778C'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
